import { Route } from '@angular/router';
import { FeatureType } from './feature-type';
import { InjectionToken } from '@angular/core';

/**
 * The configuration for a EgiPage
 */
export interface EgiPageConfig {
  /**
   * The name of the page as shown in the application configurator
   */
  name: string;
  /**
   * The id of the page (must be a GUID)
   */
  id: string;
  /**
   * The features of the page, use this section to restrict certain actions to specific groups.
   */
  features: {
    [name: string]: FeatureConfig
  };
  /**
   * The topic/subject of the page
   */
  topic?: string;
  dependencies?: {
    /**
     * Does this page need a poolName?
     */
    poolName?: true;
    /**
     * Does this page need a machineName?
     */
    machineName?: true;
  };
  /**
   * Is this a clickThroughPage? (is it only navigable via another (parent) page?
   */
  isClickThroughPage?: true;
  previewImg?: string;
  /**
   * The clickthroughPages for this page.
   */
  clickTroughPages?: {
    [name: string]: FeatureConfig
  };

  /**
   * Extra options to configure on the page
   */
  configurationOptions?: ConfigurationOptions;
}

export interface ConfigurationOptions {
  [key: string]: ConfigurationOption;
}

export interface ConfigurationOption {
  type: ConfigurationOptionType;
  required: boolean;
  showValueInBreadCrumb?: boolean;
}

export const enum ConfigurationOptionType {
  Boolean = 0,
  String = 1,
  Int,
  Double,
  URL,
  Email,
  Password
}

export interface EgiPageMetaData {
  readonly config: EgiPageConfig;
  readonly fullPathFromRoot: string;
  readonly isPage: boolean;
  readonly isRoot: boolean;
  readonly features: PageFeature[];
}

export interface FeatureConfig {
  /**
   * The ID of the feature, should be a GUID!
   * Use https://www.guidgenerator.com to generate an ID
   */
  id: string;
  /**
   * TODO: determine: what is the displayKey for? Or what was the intention behind it?
   * */
  displayKey: string;
  /**
   * Purely informative tags
   */
  tags?: string[];
  /**
   * The feature will only be accessible on one of the given deviceTypes.
   */
  requiredDeviceTypes?: DeviceType[];
}

export interface PageFeature {
  /**
   * The id of the feature
   */
  featureId: string;
  /**
   * The id of the page on which the feature is located
   */
  pageId: string;
  /**
   * The name of the feature
   */
  name: string;
  /**
   * The type of the feature
   */
  type: FeatureType;
  /**
   * Purely informative tags
   */
  tags?: string [];
  /**
   * Restricts that the feature will only be allowed on the given deviceTypes
   */
  requiredDeviceTypes?: DeviceType[];
}

export type DeviceType = 'Terminal' | 'Pompkar' | 'Heftruck' | 'HMI' | 'Bureau';

export type Constructable<T> = new (...args: any[]) => T;

export interface EgiRoute extends Route {
  [k: string]: any
  data?: {
    config?: EgiPageConfig,
    [k: string]: any
  };
  children?: EgiRoute[];
}

export type EgiRoutes = EgiRoute[];
export const EGI_PAGES_SNAPSHOT_CONFIG = new InjectionToken<EgiPagesSnapshotConfig>('');

export interface EgiPagesSnapshotConfig {
  homePageId: string;
}
